module.exports = __webpack_public_path__ + "img/green_139.c91fa181.png";